import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'


/**
 * @param {{
 *  searchString : String
 *  pageIndex: Number
 *  pageItemCount: Number
 *  category_1: Array<String>
 *  category_2: Array<String>
 *  lang: String
 *  order: Number
 *  lengthFilter: Array<String>
 *  imageCountFilter: Array<String>
 *  isShowEditableOnly: Boolean
 * }} data
 */

const GetGroupList = async (data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/template/group-list`
        const response = await axios.post(url, data);

        const result = (response.status === 200);
        const resultData = response.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {String} adminToken //필수
 * @param {{
 *  templateId : String
 * }} data  
 */

const GetConfirmState = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/template/confirm-status?templateId=${data.templateId}`
        const config = { headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config);

        const result = (response.status === 200);
        const resultData = response.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {String} adminToken //필수
 * @param {{
 *  templateId : String
 * }} data  
 */

const GetDecompressState = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/template/decompress-status?templateId=${data.templateId}`


        const config = { headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config);

        const result = (response.status === 200);
        const resultData = response.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {String} adminToken //필수
 * @param {{
 *  templateId : String
 * }} data  
 */

const GetTemplateInfo = async ( adminToken,data={}) => {
    try {
        const url = `${GetBaseUrl()}/api/template/find/${data.templateId}`
        const config = { headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.get(url, config);

        const result = (response.status === 200);
        const resultData = response.data;
      
        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {String} adminToken //필수
 * @param {{
 *  pageIndex : Number
 *  pageItemCount : Number
 *  order : Number
 *  searchString : String
 * }} data
*/

const GetNotConfirmedTemplates = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/template/notConfirmed`

        const params = { ...data }
        const config = {
            params,
            headers: { Authorization: `Bearer ${adminToken}` }
        }
        const response = await axios.get(url, config);

        const result = (response.status === 200);
        const resultData = response.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * 템플릿 등록
 * @param {string} adminToken 필수
 * @param {{
 *  data: object
 * }} data
 */
const PostTemplateRegister = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/template/register`
        const config = {
            headers: { Authorization: `Bearer ${adminToken}` }
        }
        const response = await axios.post(url, data.data, config)
        
        const result = (response.status === 200)
        const resultData = response.data
        return new Response(result, resultData)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

const GetAllTemplatesCount = async() => {
    try {
        const response = await axios.get(`${GetBaseUrl()}/api/template/allTemplatesCount`)
        const result = (response.status === 200);
        const resultData = response.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            default:
                throw e
        }
    }
}

/**
 * @param {{
 *  videoId : String
 * }} data
*/

const GetTemplateById = async (data = {}) => {
    try {
        const response = await axios.get(`${GetBaseUrl()}/api/template/findwithoutdata/${data.videoId}`)
        const result = (response.status === 200);
        const resultData = response.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}
/**
 * 템플릿 파일 서버 업로드
 * @param {string} adminToken 필수
 * @param {{
 *  formData: file
 * }} data
 */
const PostTemplateUploadFiles = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/template/upload_files`
        const config = {
            headers: { Authorization: `Bearer ${adminToken}` },
            "Access-Control-Allow-Origin": "*"
        }
        const response = await axios.post(url, data.formData, config)
        
        const result = (response.status === 200)
        const resultData = response.data
        return new Response(result, resultData)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {String} adminToken //필수
 * @param {{
 *  templateId : String
 * }} data  
 */
const PostConfirmTemplate = async (adminToken, data = {}) => {
    try {
        const config = { headers: { Authorization: `Bearer ${adminToken}`, "Access-Control-Allow-Origin": "*" } }
        const body = { template_id: data.templateId }
        const response = await axios.post(`${GetBaseUrl()}/api/template/confirm`, body, config);

        const result = (response.status === 200);
        const reslutData = response.data;

        if (reslutData !== "success") {
            throw new Error(reslutData)
        } else {   
            return new Response(result, reslutData)
        }
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            default:
                throw e
        }
    }
}

/**
 * @param {String} adminToken //필수
 * @param {{
 *  templateId : String
 *  thumnailURL : String
 * }} data  
 */
const PostChangeThumbnail = async (adminToken, data = {} ) => {
    try {
        const config = { headers: { Authorization: `Bearer ${adminToken}` } }
        const body = { template_id: data.templateId, thumnailURL: data.thumnailURL }

        const response = await axios.post(`${GetBaseUrl()}/api/template/change_thumbnail`, body, config);

        const result = (response.status === 200);
        const resultData = response.data;
        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

/**
 * @param {String} adminToken //필수 
 * @param {{
 *  templateId : String
 * }} data  
 */

const DeleteTemplate = async (adminToken, data = {}) => {
    try {
        const config = { headers: { Authorization: `Bearer ${adminToken}` } }
        const response = await axios.delete(`${GetBaseUrl()}/api/template/delete/${data.templateId}`, config)

        const result = (response.status === 200);
        const resultData = response.data;

        return new Response(result, resultData)
    } catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}
/**
 * 템플릿 파일 서버 업로드 완료
 * @param {string} adminToken 필수
 * @param {{
 *  _id: string | null
 * }} data
 */
const PostTemplateUploadFinish = async (adminToken, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/template/upload_finish`
        const config = {
            headers: { Authorization: `Bearer ${adminToken}` },
            "Access-Control-Allow-Origin": "*"
        }
        const response = await axios.post(url, { _id: data._id }, config)
        
        const result = (response.status === 200)
        const resultData = response.data
        return new Response(result, resultData)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_PARAM:
            case PUBLIC_ERROR_CODE.ERR_NOT_FOUND:
                return new Response(false, publicErrorCode)
            case PUBLIC_ERROR_CODE.ERR_INTERNAL_ERROR:
            default:
                throw e
        }
    }
}

export default {
    GetConfirmState,
    GetDecompressState,
    GetTemplateInfo,
    GetNotConfirmedTemplates,
    GetAllTemplatesCount,
    GetTemplateById,
    PostConfirmTemplate,
    PostChangeThumbnail,
    DeleteTemplate,
    GetGroupList,
    PostTemplateRegister,
    PostTemplateUploadFiles,
    PostTemplateUploadFinish
}
